import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors } from '../../constants'

const BoardStyled = styled.div`
    background: ${colors.white};
    box-shadow: -1px 0px 6px #0000002c;
    height: 100%;
    position: absolute;
    top: 0;
    // transition: all 0.5s;
    z-index: 2;

    ${({ isMobile }) => (isMobile ? `right: -100%; width: 100%;` : `left: -100%; width: calc(100% - 800px);`)}

    ${({ isOpen }) => isOpen && `left: 800px;`}

  ${({ isWideOpen, isMobile }) =>
        isWideOpen &&
        `
      ${isMobile ? `left: 100%;` : `left: 363px;`}
      z-index: 2;
    `}
`

const Board = ({ children, isOpen, isWideOpen, isMobile, onClose, ...props }) => (
    <BoardStyled isOpen={isOpen} isWideOpen={isWideOpen} isMobile={isMobile} {...props}>
        {children}
    </BoardStyled>
)

Board.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    isWideOpen: PropTypes.bool,
    onClose: PropTypes.func,
    isMobile: PropTypes.bool,
}

Board.defaultProps = {
    children: null,
    isOpen: false,
    isWideOpen: false,
    onClose: () => null,
    isMobile: false,
}

export default Board
